module Omni.ResortMap {
    ngModule.directive('roomLayout', (['$document',
        function ($document) {
            return {
                restrict: 'EA',
                link: function (scope, element, attrs) {

                    function getOffset(index, length) {
                        if (length > 5) {
                            var left, right;
                            left = 2;
                            right = length - 3;

                            // index is on the far left
                            if (index <= left) {
                                return 0;

                                // index is on the far right
                            } else if (index >= right) {
                                return (right - 2);

                                // index is somewhere in the middle
                            } else {
                                return (index - 2);
                            }
                        }
                    }

                    var partials = scope.partials;
                    var s, a, c, p;
                    var part = 0;
                    var layouts = partials[part];
                    scope._Index = 0;

                    s = $document.find("#partialSelect");
                    a = $document.find("#area");
                    c = $document.find("#ceiling");
                    p = $document.find("#capacity");
                    var body = $document.find("body");
                    var bodyWidth = body.width();

                    var offsetLength = 80;
                    if (bodyWidth >= 1200) {
                        offsetLength = 117;
                    } else if (bodyWidth < 1200 && bodyWidth >= 992) {
                        offsetLength = 92;
                    } else if (bodyWidth < 992 && bodyWidth >= 768) {
                        offsetLength = 83;
                    }

                    s.on("change", function (e) {
                        part = e.target.value;
                        scope.layouts = partials[part].layout;
                        a.html(partials[part].area);
                        c.html(scope.room.ceiling);
                        p.html(partials[part].capacity);
                        scope._Index = 0;
                        scope.length = scope.layouts.length;
                        scope.$digest();
                    });

                    scope.length = scope.layouts.length;

                    scope.$watch('_Index', function () {
                        var offset = getOffset(scope._Index, scope.length);
                        jQuery("#layoutNav").animate({
                            left: -(offset * offsetLength)
                        });
                    });

                    scope.isActive = function (index) {
                        return scope._Index === index;
                    };
                    scope.showPrev = function () {
                        var oldIndex = angular.copy(scope._Index);
                        scope._Index = (scope._Index > 0) ? --scope._Index : scope.length - 1;
                    };

                    scope.showNext = function () {
                        var oldIndex = angular.copy(scope._Index);
                        scope._Index = (scope._Index < scope.length - 1) ? ++scope._Index : 0;
                    };

                    scope.showPhoto = function (index) {
                        var oldIndex = angular.copy(scope._Index);
                        scope._Index = index;
                    };

                    scope.setWidth = function (len) {
                        return len > 5;
                    }
                }
            };
        }]) as any);
}
